import type { OverlayRef } from '@angular/cdk/overlay';
import { FlexibleConnectedPositionStrategy } from '@angular/cdk/overlay';

export class RtFlexibleConnectedPositionStrategy extends FlexibleConnectedPositionStrategy {
  public overlayLevel: number | null = null;
  public overlayRef: OverlayRef | null = null;

  public withOverlayLevel(level: number) {
    this.overlayLevel = level;
    return this;
  }

  public attach(overlayRef: OverlayRef) {
    this.overlayRef = overlayRef;
    super.attach(overlayRef);
  }

  public apply() {
    super.apply();
    if (this.overlayRef?.hostElement && this.overlayLevel !== null) {
      this.overlayRef.hostElement.style.zIndex = `${this.overlayLevel}`;
    }
  }
}
